import React from "react";

const EnvBadge = () => {
  const env = process.env.REACT_APP_ENV;

  if (!env || env === "production") {
    return null
  }

  return (
      <div className="env-badge">{env}</div>
  );
};

export default EnvBadge;
